import type { ReactNode } from "react";
import { Typography } from "antd";
import { useRegisterCrumb } from "../context/BreadcrumbContext";
import { useRecordVisit } from "../context/HistoryContext";

export function PageHeader({ title, extra, subtitle }: { title: string; extra?: ReactNode; subtitle?: ReactNode }) {
  // Every page renders a PageHeader, so this is also where the breadcrumb trail learns
  // the name of the current page (a document number on detail routes), and where the
  // recent-pages list gets a readable name for the route.
  useRegisterCrumb(title);
  useRecordVisit(title);

  return (
    <div className="glut-page-header" data-tour="page-header">
      <div>
        <Typography.Title level={3} style={{ margin: 0 }}>
          {title}
        </Typography.Title>
        {subtitle && <Typography.Text type="secondary">{subtitle}</Typography.Text>}
      </div>
      {extra && <div data-tour="page-actions">{extra}</div>}
    </div>
  );
}
